
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import { Operation } from '../operation/operation';
import { OperationService, OperationFilter } from '../operation/operation.service';
import { OperationFilterDialogComponent } from '../operation/operation-filter-dialog.component';
import { NotifierService, DialogService } from '../ui';

@Component({
  selector: 't-select-operation',
  templateUrl: './select-operation.component.html',
})
export class SelectOperationComponent implements OnInit, OnChanges {
  
  filter: OperationFilter;

  perPage = 10
  operationsCount: number = 0
  operations: Operation[]

  @Input() selectedOperation: Operation
  @Output() selectedOperationChange = new EventEmitter();

  @Input() showFilter: boolean
  @Output() showFilterChange = new EventEmitter();

  constructor(
    private operationService: OperationService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new OperationFilter();

    // Set default ordering to NAME/ASC
    this.filter.order_by = 'NAME';
    this.filter.order_direction = 'ASC';
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.operations.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.operationService
      .operations(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.operations = result.operations;
        }
        // Append
        else {
          this.operations = [...this.operations || [], ...result.operations];
        }

        this.operationsCount = result.operationsCount;
      });
  }

  onSelect(operation: Operation) {
    this.selectedOperation = operation;
    this.selectedOperationChange.emit(operation);

    return false;
  }

  applyFilter() {
    this.dialogService.show({
      component: OperationFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
          this.showFilter = false;
          this.showFilterChange.emit(false);
        },

        onApply: (filter: OperationFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['showFilter']) {
      if(this.showFilter) {
        this.applyFilter();
      }
    }
  }
}
